(() => {
  const states = new WeakMap();

  const buildState = (element) =>
    runAttribute(
      [element],
      "x-data",
      (attr) => `const val = (${attr});return (typeof val === 'function' ? val.call(this): val)`,
    )[0] || {};

  const getState = (element) =>
    states.get(element) || (states.set(element, buildState(element)) && states.get(element));
  window.X = getState;

  const runAttribute = (elements, attribute, transform = (x) => x) =>
    elements
      .map((elem) => [elem, elem?.getAttribute?.(attribute)])
      .map(([elem, attrValue]) => attrValue && new Function(transform(attrValue)).call(elem));

  const setupXLoad = () => {
    runAttribute([...document.querySelectorAll("[x-mount]")], "x-mount");
    new MutationObserver(function (mutation) {
      const addedNodes = mutation.flatMap((m) => m.addedNodes).flatMap((nodes) => [...nodes]);
      const removedNodes = mutation.flatMap((m) => m.removedNodes).flatMap((nodes) => [...nodes]);

      runAttribute(addedNodes, "x-mount");
      runAttribute(removedNodes, "x-unmount");
    }).observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", setupXLoad);
  } else {
    setupXLoad();
  }
})();
